<template>
    <div class="profile-card">
        <ProfileCardHeader
            :availability="profile.availability_status"
            :avatar-url="profile.avatar_url"
            :score="profile.percentage_score_avg"
        />
        <ProfileCardScores
            :scores="profile.scores"
            :main-filters="mainFilters"
        />
        <ProfileCardButton
            :profile="profile"
            @showConfirmationModal="
                (profile) => $emit('showConfirmationModal', profile)
            "
        />
        <ProfileCardRequestDossierButton
            :profile="profile"
            :group-name="groupName"
        />
        <ProfileCardManagerProfileButton
            v-if="profile.web_profile_url"
            :url="profile.web_profile_url"
        />
        <Collapse
            v-show="profile.content_job_scorings.length"
            :title="
                $trans(
                    'web_search.profile_card.relevant_professional_experience',
                )
            "
        >
            <ProfileJobCompetenceScoring :data="profile.content_job_scorings" />
        </Collapse>
        <Collapse
            v-show="profile.content_industry_scorings.length"
            :title="
                $trans('web_search.profile_card.relevant_industry_experience')
            "
        >
            <ProfileIndustryCompetenceScoring
                :data="profile.content_industry_scorings"
            />
        </Collapse>
        <Collapse
            v-show="profile.content_qualifications.length"
            :title="$trans('web_search.profile_card.qualifications')"
        >
            <ProfileQualifications :data="profile.content_qualifications" />
        </Collapse>
        <Collapse
            v-show="profile.content_publications.length"
            :title="$trans('web_search.profile_card.publications')"
        >
            <ProfilePublications :data="profile.content_publications" />
        </Collapse>
        <div class="profile-footer">
            {{ $trans('web_search.profile_card.candidate_provided_by') }}
            <a :href="link" class="profile-link" target="_blank">{{
                linkText
            }}</a>
        </div>
    </div>
</template>

<script>
import Collapse from "../Utils/Collapse.vue";
import ProfileCardButton from "./ProfileCardButton.vue";
import ProfileCardRequestDossierButton from "./ProfileCardRequestDossierButton.vue";
import ProfileCardManagerProfileButton from "./ProfileCardManagerProfileButton.vue";
import ProfileCardHeader from "./ProfileCardHeader.vue";
import ProfileCardScores from "./ProfileCardScores.vue";
import ProfileIndustryCompetenceScoring from "./ProfileIndustryCompetenceScoring.vue";
import ProfileJobCompetenceScoring from "./ProfileJobCompetenceScoring.vue";
import ProfileQualifications from "./ProfileQualifications.vue";
import ProfilePublications from "./ProfilePublications.vue";

export default {
    components: {
        Collapse,
        ProfileCardButton,
        ProfileCardRequestDossierButton,
        ProfileCardManagerProfileButton,
        ProfileCardHeader,
        ProfileCardScores,
        ProfileJobCompetenceScoring,
        ProfileIndustryCompetenceScoring,
        ProfileQualifications,
        ProfilePublications,
    },
    props: {
        profile: {
            type: Object,
            required: true,
        },
        mainFilters: {
            type: Array,
            required: true,
        },
        groupName: String,
    },
    computed: {
        linkText() {
            if (this.profile.pool_partner_name) {
                return this.profile.pool_partner_name;
            }

            switch (this.profile.group_id) {
                case 1:
                    return "Deutsche Interim AG";
                case 30:
                    return "Swiss Interim";
                case 32:
                    return "Matchmaker";
                default:
                    return "Matchmaker";
            }
        },

        link() {
            if (this.profile.pool_partner_url) {
                return this.profile.pool_partner_url;
            }

            switch (this.profile.group_id) {
                case 1:
                    return "https://www.deutscheinterim.com";
                case 30:
                    return "https://www.swissinterim.com";
                case 32:
                    return "https://www.matchmaker.de";
                default:
                    return "https://www.matchmaker.de";
            }
        },
    },
};
</script>

<style scoped>
.profile-card {
    color: #000;
    width: 400px;
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
    background: white;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: 1px solid #bcbab6;
}

.profile-footer {
    margin-bottom: -25px;
    margin-top: -10px;
    font-size: 14px;
    text-align: right;
    font: italic normal normal 15px/55px Barlow;
    letter-spacing: -0.36px;
    color: #8e8d8c;
}

.profile-link {
    text-align: right;
    font: italic normal normal 15px/55px Barlow;
    letter-spacing: -0.36px;
    color: #8e8d8c;
    opacity: 1;
    text-decoration: underline;
}

@media (max-width: 768px) {
    .profile-footer {
        font: italic normal normal 13px/55px Barlow;
    }

    .profile-link {
        font: italic normal normal 15px/55px Barlow;
    }
}
</style>